<template>
  <div class="intro">
    <div class="intro__container">
      <div class="intro__text">
        <p class="intro__title">{{labels.intro.title}}</p>
        <p
          class="intro__caption"
          :class="showPageTwoClass"
          :style="showPageTwoStyle"
        >{{labels.intro.tagline}}</p>
      </div>
      <invader :isPaused="showPageThree" :speed="pageOneSpeed" :loops="2" class="intro__animation" />
    </div>
    <div class="intro__background" :class="backgroundClass" :style="backgroundStyles"></div>
  </div>
</template>

<script>
import Invader from "./Invader.vue";
import { mapGetters } from "vuex";
import { vuexGetters } from "../store";

export default {
  name: "Intro",
  data() {
    return {
      startPageTwo: false,
      showPageTwo: false,
      startPageThree: false,
      showPageThree: true
    };
  },
  props: {
    pageOneSpeed: {
      type: Number,
      default: 3
    },
    pageTwoSpeed: {
      type: Number,
      default: 2.8
    },
    pageThreeSpeed: {
      type: Number,
      default: 2
    },
    fadeInSpeed: {
      type: Number,
      default: 2
    }
  },
  components: {
    Invader
  },
  created() {
    // Set timeout to fade in page 2 elements
    setTimeout(() => {
      this.showPageTwo = true;
    }, (this.pageOneSpeed - this.pageTwoSpeed) * 1000);

    // Set timeout to start page 2 animation
    setTimeout(() => {
      this.startPageTwo = true;
    }, this.pageTwoSpeed * 1000);

    // Set timeout to get end of page 2 animations
    setTimeout(() => {
      this.showPageThree = true;
    }, (this.pageOneSpeed + 0.5) * 2 * 1000);

    this.showPageThree = false;

    // Emit end
    setTimeout(() => {
      this.$emit("ended");
    }, (this.pageOneSpeed + this.pageTwoSpeed + this.pageThreeSpeed) * 1000);
  },
  computed: {
    ...mapGetters({
      labels: vuexGetters.I18N
    }),
    showPageTwoClass() {
      return {
        visible: this.showPageTwo
      };
    },
    showPageTwoStyle() {
      return {
        "--fade-speed": `${this.fadeInSpeed}s`
      };
    },
    startPageTwoClass() {
      return {
        animate: this.startPageTwo
      };
    },
    backgroundClass() {
      return {
        ...this.showPageTwoClass,
        ...this.startPageTwoClass
      };
    },
    backgroundStyles() {
      return {
        ...this.showPageTwoStyle,
        "--scale-speed": this.pageTwoSpeed
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.intro {
  background: url("../assets/layout/background.png") no-repeat center;
  @include forRetina {
    background-image: url("../assets/layout/background@2x.png");
  }
  background-size: cover;
  height: 100vh;
  width: 100%;
  position: relative;
  display: grid;
  grid-template-areas: "content" "spacer";
  grid-template-rows: repeat(2, 1fr);
  overflow: hidden;

  &:before {
    background: transparent
      linear-gradient(
        180deg,
        rgba($white, 0) 0%,
        rgba($east-side, 0.48) 38%,
        rgba($sience-blue, 1) 100%
      )
      0% 0% no-repeat padding-box;
    opacity: 0.64;
    content: "";
    position: absolute;
    height: 293px;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &:after {
    content: "";
    height: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      to top,
      rgba(darken($sience-blue, 30%), 1) 5px,
      rgba(darken($sience-blue, 30%), 0)
    );
    z-index: 20;
  }

  &__container {
    grid-area: content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 5;

    @media screen and (min-width: 768px) {
      width: 718px;
      margin: 0 auto;
    }
  }

  &__text {
    color: white;
    text-align: center;
    line-height: 2.375rem;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 700;
  }

  .spacer {
    grid-area: spacer;
  }

  &__caption {
    font-size: 2rem;
    font-weight: 300;
    transition: all;
    transition-duration: var(--fade-speed);
    transition-timing-function: ease-in-out;
    opacity: 0;

    &.visible {
      opacity: 1;
    }
  }

  &__animation {
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
  }

  &__background {
    background: url("../assets/layout/blue-containers.png") no-repeat center;
    @media screen and (min-width: 768px) {
      background: url("../assets/layout/blue-containers-desktop.png") no-repeat
        center;
    }
    @include forRetina {
      background-image: url("../assets/layout/blue-containers@2x.png");
      @media screen and (min-width: 768px) {
        background-image: url("../assets/layout/blue-containers-desktop@2x.png");
      }
    }
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-size: cover;
    transform-origin: bottom left;
    transition: all;
    transition-duration: var(--fade-speed);
    transition-timing-function: ease-in-out;
    opacity: 0;

    &.visible {
      opacity: 1;
    }

    &.animate {
      animation: boxScale;
      animation-duration: var(--scale-speed);
      animation-timing-function: ease-in;
      transform: scale(1.4);
    }
  }
}

@keyframes boxScale {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.4);
  }
}
</style>